export const SYSTEM_ORG_IDS = {
    SYSTEM_CONSOLE: -1n,
    NOT_APPLICABLE: -999n,
    /*
        Unallocated org id is store in DB as null.
    */
    UNALLOCATED: -9999n,

    FIRST_VALID_ORG_ID: 1n,
} as const;

/**
 * Ids at/above this floor are reserved for ephemeral E2E orgs, allocated from the
 * dedicated "EphemeralOrg_id_seq" sequence so test churn never advances the real
 * tenant autoincrement sequence (CUR-219).
 */
export const EPHEMERAL_ORG_ID_FLOOR = 9_000_000n;
